import React from "react";
import {ColProps, RowProps} from "antd/lib/grid";


export class FormUIConfig {

  noLabels: boolean = false;

  row: RowProps = {
    style: {
      marginBottom: 24
    }
  };

  label: ColProps = {

  };

  control: ColProps = {

  };

}

export const NULL_CONFIG: FormUIConfig = Object.freeze(new FormUIConfig());

export const FormUIConfigContext = React.createContext<FormUIConfig>(NULL_CONFIG);

export function buildFormUIConfig(isDesktop: boolean, isTablet: boolean, isMobile: boolean): FormUIConfig {
  const cfg = new FormUIConfig();

  const isTouchscreen = isTablet || isMobile;

  if (isTouchscreen) {
    cfg.label.style = {
      marginBottom: 6
    }
  }
  cfg.label.span = isTouchscreen ? 24 : 4;

  cfg.control.span = isTouchscreen ? 24 : 12;

  return cfg;
}